import React from "react";
import {FaAlignLeft, FaComment, FaPaperclip, FaSquareCheck, FaUsers} from "react-icons/fa6";

const Indicator = ({icon: Icon, value, title}) => (
    <span title={title} className="flex items-center gap-1"><Icon />{value !== undefined && value}</span>
);

const CardIndicators = ({card, className = ""}) => {
    const checklist = Array.isArray(card.checklists)
        ? card.checklists.flatMap(checklist => checklist.items ?? [])
        : card.checklist ?? [];
    const hasChecklist = (card.checklists?.length ?? 0) > 0 || checklist.length > 0;
    const completed = checklist.filter(item => item.completed).length;
    const hasIndicators = Boolean(
        card.description
        || hasChecklist
        || (card.comments?.length ?? card.comments ?? 0) > 0
        || (card.assignees?.length ?? 0) > 0
        || (card.attachments?.length ?? 0) > 0
    );

    if (!hasIndicators) return null;

    return (
        <div className={`flex flex-wrap items-center gap-2.5 text-[11px] text-slate-500 ${className}`}>
            {card.description && <Indicator icon={FaAlignLeft} title="Possui descrição" />}
            {hasChecklist && <Indicator icon={FaSquareCheck} value={`${completed}/${checklist.length}`} title="Checklist" />}
            {(card.comments?.length ?? card.comments ?? 0) > 0 && <Indicator icon={FaComment} value={card.comments?.length ?? card.comments} title="Comentários" />}
            {(card.assignees?.length ?? 0) > 0 && <Indicator icon={FaUsers} value={card.assignees.length} title="Membros" />}
            {(card.attachments?.length ?? 0) > 0 && <Indicator icon={FaPaperclip} value={card.attachments.length} title="Anexos" />}
        </div>
    );
};

export default CardIndicators;
